module.exports = __webpack_public_path__ + "static/Jason-Alexander_Cristina-Jones-9953f9f17e3a6f8691f4aca55dddf156.jpg";